<template>
  <div>
    <doctor-header></doctor-header>
    <div class="header-separator"></div>
    <div style="background-color: rgba(255, 255, 255, 0.9); margin-top: 200px">
      <v-container class="site-padding" id="aboutActionSection">
        <v-layout row wrap class="doctors-container">
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header doctors-container--header pt-4">
              Regulamin akcji „POLSCY OKULIŚCI KONTRA JASKRA"
            </h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle"></div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="my-text doctors-container">
          <v-flex xs12 class="text-xs-left">
            <span class="doctors-container--sections text-capitalize"
              >I. DEFINICJE</span
            >
            <div class="pb-3">
              <ol>
                <li>
                  „Akcja” – akcja społeczna „Polscy Okuliści Kontra Jaskra”
                  prowadzona na zasadach określonych w Regulaminie.
                </li>
                <li>
                  „Organizator” lub „Organizator Akcji” Akcji” – firma Compass
                  Public Relations s.c. K. Waligóra, A. Pawlikowska z siedzibą w
                  Warszawie przy ul. Chłodnej 64 lok. 223 (kod: 00-872), NIP:
                  525-258-22-05, REGON: 147104984.
                </li>
                <li>
                  „Beneficjent” – Polskie Towarzystwo Okulistyczne z siedzibą w
                  Warszawie przy ul. Lindleya 4, zarejestrowane w Sądzie
                  Rejonowym dla miasta stołecznego Warszawy XII Wydziale
                  Gospodarczym, pod nr KRS: 0000143922, posiadającym nr REGON:
                  000811595, NIP: 5262364898.
                </li>
                <li>
                  „Uczestnik” – osoba fizyczna (lekarz, pacjent) biorąca udział
                  w Akcji.
                </li>
                <li>
                  „Strona internetowa Akcji” – strona:
                  <router-link
                    :to="{ name: 'Homepage' }"
                    class="doctors-container--links"
                    >www.tydzienjaskry.pl</router-link
                  >.
                </li>
                <li>
                  „Kwota wsparcia” – ostateczna kwota, przekazana przez
                  Partnerów Akcji, którą Organizator Akcji zobowiązuje się
                  wykorzystać na realizację prac nad Akcją.
                </li>
              </ol>
            </div>
            <span class="doctors-container--sections text-capitalize"
              >II. POSTANOWIENIA OGÓLNE
            </span>
            <div class="pb-3">
              <ol>
                <li>
                  Organizatorem Akcji „Polscy Okuliści Kontra Jaskra” (zwaną w dalszej 
                  części Regulaminu: „Akcją”) jest firma Compass Public Relations s.c. K. Waligóra, 
                  A. Pawlikowska z siedzibą w Warszawie przy ul. Chłodnej 64 lok. 223 (kod: 00-872), 
                  NIP: 525-258-22-05, REGON: 147104984, zwana w dalszej części Regulaminu „Organizatorem” 
                  lub „Organizatorem Akcji”. 
                </li>
                <li>
                  Beneficjentem Akcji jest Polskie Towarzystwo Okulistyczne z siedzibą w Warszawie 
                  przy ul. Lindleya 4, zarejestrowane w Sądzie Rejonowym dla miasta 
                  stołecznego Warszawy XII Wydziale Gospodarczym, pod nr KRS: 0000143922, 
                  posiadającym nr REGON: 000811595, NIP: 5262364898, zwane w dalszej części 
                  Regulaminu „Beneficjentem” lub „Beneficjentem Akcji”. 
                </li>
                <li>
                  Akcja jest organizowana na terytorium Rzeczypospolitej Polskiej i skierowana 
                  jest do lekarzy, pacjentów, pracowników administracji 
                  placówek medycznych oraz innych ośrodków i organizacji.
                </li>
                <li>
                  Akcja rozpoczyna się dnia 13.01.2026 r. i kończy 14.03.2026 r. o godzinie 23:59. 
                </li>
                <li>
                  Organizator zastrzega sobie prawo zmiany w każdym czasie
                  postanowień niniejszego Regulaminu, w szczególności w
                  przypadku zmian przepisów prawa lub innych nieprzewidzianych
                  zdarzeń mających istotny wpływ na przeprowadzenie Akcji.
                </li>
                <li>
                  Przystąpienie do Akcji oznacza akceptację zasad Akcji
                  przedstawionych w niniejszym Regulaminie.
                </li>
                <li>
                  Regulamin Akcji będzie dostępny na stronie:
                  <router-link
                    :to="{ name: 'Homepage' }"
                    class="doctors-container--links"
                    >www.tydzienjaskry.pl</router-link
                  >
                  oraz w siedzibie Organizatora.
                </li>
              </ol>
            </div>
            <span class="doctors-container--sections text-capitalize"
              >III. ZASADY AKCJI</span
            >
            <div class="pb-3">
              <ol>
                <li>
                  Celami akcji są:<br />
                  <ul>
                    <li>
                      podnoszenie świadomości społeczeństwa na temat jaskry oraz
                      nowoczesnych metod jej leczenia,
                    </li>
                    <li>
                      zwiększanie wykrywalności jaskry we wczesnych stadiach
                      zaawansowania.
                    </li>
                  </ul>
                </li>
                <li>
                  Organizator Akcji, na zasadach określonych w Regulaminie,
                  będzie zobowiązany wykorzystać przekazaną mu przez Partnerów
                  Akcji Kwotę wsparcia na realizację prac nad Akcją.
                </li>
              </ol>
            </div>
            <span class="doctors-container--sections text-capitalize"
              >IV. WARUNKI UCZESTNICTWA i&nbsp;ZASADY PRZEPROWADZANIA
              AKCJI</span
            >
            <div class="pb-3">
              <ol>
                <li>
                  W Akcji mogą brać udział osoby fizyczne, zamieszkałe na
                  terytorium Rzeczypospolitej Polskiej, które ukończyły
                  osiemnasty rok życia i posiadają pełną zdolność do czynności
                  prawnych.
                </li>
                <li>
                  Uczestnikiem Akcji mogą być wyłącznie osoby, które
                  zaakceptowały w ramach zgłoszenia Regulamin Akcji.
                </li>
                <li>
                  Uczestnikami Akcji mogą być:<br />
                  <ul>
                    <li>
                      lekarze okuliści posiadający aktualne Prawo Wykonywania
                      Zawodu, zatrudnieni w podmiotach leczniczych,
                    </li>
                    <li>
                      pacjenci, którzy nie odwiedzili okulisty przez ostatni rok
                      i nie są chorzy na jaskrę,
                    </li>
                    <li>pracownicy administracji podmiotów leczniczych.</li>
                  </ul>
                </li>
                <li>
                  Uczestnictwo w Akcji ma charakter społeczny, jest dobrowolne i
                  bezpłatne.
                </li>
                <li>
                  Rejestracja Uczestników odbywa się w formie elektronicznej
                  przez formularz dostępny na stronie internetowej:
                  <router-link
                    :to="{ name: 'Homepage' }"
                    class="doctors-container--links"
                    >www.tydzienjaskry.pl</router-link
                  >.
                </li>
                <li>
                  Prawidłowa rejestracja Uczestnika następuje po podaniu
                  następujących danych osoby zgłaszającej oraz danych placówki:
                  imię i nazwisko zgłaszającego, telefon, adres e-mail, nazwa
                  placówki, adres (ulica i numer porządkowy, kod pocztowy,
                  miasto), numer telefonu do placówki, preferowana liczba
                  pacjentów, godziny przyjęć.
                </li>
                <li>
                  Osoba dokonująca zgłoszenia Uczestnika jest zobowiązana do
                  wyrażenia zgody na udział w Akcji i otrzymywanie informacji o
                  jej przebiegu, w tym drogą elektroniczną i telefoniczną.
                </li>
                <li>
                  Każdy Uczestnik bierze udział w Akcji na własną
                  odpowiedzialność, w szczególności Organizator ani Partnerzy
                  Akcji, ani Beneficjent, nie ponoszą odpowiedzialności za
                  jakiekolwiek szkody na osobie lub mieniu powstałe w związku z
                  udziałem Uczestnika w Akcji.
                </li>
              </ol>
            </div>

            <span class="doctors-container--sections text-capitalize"
              >V. ZASADY ZGŁASZANIA GABINETÓW i&nbsp;PRZEBIEG AKCJI</span
            >
            <div class="pb-3">
              <ol>
                <li>
                  Zgłoszenia podmiotu leczniczego może dokonać lekarz lub pracownik administracyjny tegoż podmiotu.
                </li>
                <li>
                  Aby wziąć udział w akcji, lekarz lub pracownik administracyjny powinien 
                  zgłosić gabinet w terminie 13.01-02.03.2026 r. przez formularz zgłoszeniowy dostępny na stronie: 
                  <router-link
                    :to="{ name: 'Homepage' }"
                    class="doctors-container--links"
                    >www.tydzienjaskry.pl</router-link
                  >
                  zgodnie z obowiązującymi zasadami przyjmowania zgłoszeń określonymi w Regulaminie. 
                </li>
                <li>
                  Każde zgłoszenie gabinetu przez lekarza lub pracownika
                  administracyjnego podlega weryfikacji, która następuje w
                  momencie wypełnienia przez osobę zgłaszającą internetowego
                  formularza, następnie wydrukowanie potwierdzenia zgłoszenia
                  przesłanego e-mailem na adres wskazany w formularzu i
                  odesłanie skanu dokumentu opatrzonego pieczątką placówki na
                  adres:
                  <a
                    href="mailto:tydzienjaskry@pto.com.pl"
                    class="doctors-container--links"
                    >tydzienjaskry@pto.com.pl</a
                  >.
                </li>
                <li>
                  Prawidłowa rejestracja Uczestnika następuje po podaniu
                  następujących danych osoby zgłaszającej oraz danych placówki:
                  imię i nazwisko zgłaszającego, telefon, adres e-mail, nazwa
                  placówki, adres (ulica i numer porządkowy, kod pocztowy,
                  miasto), numer telefonu do placówki, preferowana liczba
                  pacjentów, godziny przyjęć.
                </li>
              </ol>
            </div>

            <span class="doctors-container--sections text-capitalize"
              >VI. ZASADY REJESTRACJI NA BEZPŁATNE WIZYTY LEKARSKIE</span
            >
            <div class="pb-3">
              <ol>
                <li>
                  Aby wziąć udział w akcji, pacjent jest zobowiązany
                  zarejestrować się telefonicznie na wizytę.
                </li>
                <li>
                  Pacjent może za pomocą strony: www.tydzienjaskry.pl ustalić
                  lokalizację zgłoszonego do Akcji gabinetu w najbliższej
                  okolicy, godziny przyjęć oraz dane kontaktowe (nazwa placówki,
                  adres, godziny przyjęć, dni przyjęć).
                </li>
                <li>
                  Wizyta jest bezpłatna i nie wymaga skierowania do okulisty.
                </li>
                <li>
                  Warunkiem uczestnictwa w Akcji jest niezdiagnozowana jaskra.
                </li>
              </ol>
            </div>

            <span class="doctors-container--sections text-capitalize"
              >VII. DANE OSOBOWE I&nbsp;PRAWO DO KORZYSTANIA
              z&nbsp;WIZERUNKU</span
            >
            <div class="pb-3">
              <ol>
                <li>
                  Uczestnicy Akcji, podając swoje dane osobowe, wyrażają zgodę i
                  upoważniają Organizatora do przetwarzania tych danych
                  osobowych do celów organizacji Akcji, oraz innych prawnie
                  usprawiedliwionych celów Organizatora, w szczególności w
                  celach marketingowych, obejmujące przesyłanie informacji drogą
                  telefoniczną lub pocztową.
                </li>
                <li>
                  Uczestnikom Akcji przysługuje prawo wglądu do swoich danych
                  osobowych, poprawy ich treści oraz żądania zaprzestania ich
                  przetwarzania.
                </li>
                <li>
                  Przekazanie danych osobowych przez Uczestnika ma charakter
                  dobrowolny, ale jest konieczne do wzięcia udziału w Akcji.
                  Uczestnik ma w każdej chwili prawo do uzyskania informacji o
                  treści przetwarzanych danych oraz ich poprawiania i usunięcia,
                  o ile jest to zgodne z obowiązującymi przepisami prawa.
                </li>
                <li>
                  Organizator informuje, iż podane dane osobowe będą
                  przetwarzane zgodnie z ustawą z dnia 29 sierpnia 1997 r. o
                  ochronie danych osobowych (Dz. U. 2002 Nr 101., poz. 926 ze
                  zm.).
                </li>
              </ol>
            </div>

            <span class="doctors-container--sections text-capitalize"
              >VIII. REKLAMACJE i&nbsp;ODPOWIEDZIALNOŚĆ</span
            >
            <div class="pb-3">
              <ol>
                <li>
                  Wszelkie reklamacje dotyczące przebiegu Akcji mogą być
                  składane na adres Organizatora na piśmie w terminie do 14
                  (słownie: czternastu) dni od daty wystąpienia zdarzenia
                  podlegającego reklamacji na adres:
                  <a
                    href="mailto:tydzienjaskry@pto.com.pl"
                    class="doctors-container--links"
                    >tydzienjaskry@pto.com.pl</a
                  >.
                </li>
                <li>
                  Za datę wniesienia reklamacji uważa się datę jej dotarcia na
                  adres Organizatora.
                </li>
                <li>
                  Reklamacja powinna zawierać imię i nazwisko oraz adres
                  zamieszkania i adres mailowy składającego reklamację wraz z
                  dokładnym opisem wskazującym na powód reklamacji.
                </li>
                <li>
                  Organizator w terminie 30 (słownie: trzydziestu) dni od
                  otrzymania reklamacji rozpatrzy zgłoszoną reklamację i
                  pisemnie poinformuje zgłaszającego ją o zajętym stanowisku.
                </li>
                <li>
                  Organizator nie ponosi odpowiedzialności za działania osób
                  trzecich, uniemożliwiające wzięcie udziału w Akcji przez jej
                  Uczestników.
                </li>
                <li>
                  Organizator nie ponosi odpowiedzialności za podanie przez
                  Uczestników nieprawdziwych danych.
                </li>
                <li>
                  Organizator nie ponosi odpowiedzialności za powstałe szkody
                  spowodowane podaniem nieprawdziwych danych przez Uczestnika
                  Akcji.
                </li>
                <li>
                  Organizator i Beneficjent nie odpowiadają za liczbę miejsc i
                  dostępność wizyt w placówkach. Każdy z gabinetów sam decyduje,
                  w jakich dniach i godzinach będzie przeprowadzał badania i ile
                  miejsc może udostępnić. Liczba miejsc jest ograniczona.
                  Decyduje kolejność zgłoszeń.
                </li>
              </ol>
            </div>

            <span class="doctors-container--sections text-capitalize"
              >IX. POSTANOWIENIA KOŃCOWE</span
            >
            <div class="pb-3">
              <ol>
                <li>
                  Organizator ma prawo w każdym momencie trwania Akcji wykluczyć
                  z udziału w nim Uczestnika Akcji, jeżeli podjął w stosunku do
                  niego uzasadnione podejrzenie działalności sprzecznej z
                  Regulaminem.
                </li>
                <li>
                  Regulamin jest jedynym dokumentem określającym zasady udziału
                  w Akcji. W kwestiach nieuregulowanych Regulaminem stosuje się
                  przepisy Kodeksu Cywilnego.
                </li>
                <li>
                  Wiążącą moc prawną mają wyłącznie postanowienia niniejszego
                  Regulaminu, a materiały reklamowe i promocyjne Akcji mają
                  jedynie charakter informacyjny.
                </li>
                <li>
                  Organizator Akcji zastrzega sobie prawo zmiany terminów Akcji,
                  a nawet odwołania Akcji w przypadku zdarzeń losowych, w tym
                  siły wyższej.
                </li>
              </ol>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <div class="header-separator" style="height: 50px"></div>
  </div>
</template>

<script>
import DoctorHeader from "@/components/partials/DoctorHeader";

export default {
  data() {
    return {};
  },
  components: {
    DoctorHeader,
  },
  beforeMount() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.doctors-container--header {
  color: rgb(164, 22, 17);
}
.doctors-container--links {
  color: #a41611;
  font-family: "Fira Sans", sans-serif;
}
.doctors-container--sections {
  color: #275271;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}
.doctors-container--sections-brown {
  color: #a41611;
}
.doctors-container--sections-slim {
  color: #000;
  font-weight: 500;
  text-transform: lowercase;
}
.doctors-container--icons {
  background: #275271;
  vertical-align: middle;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  line-height: 120px;
  border: none;
  padding: 20px;
}
.doctors-container--icons-brown {
  background: #a82824;
}
.sparator-container {
  border-bottom: 1px solid black;
  margin-bottom: 10px;
}
.sparator-rectangle {
  width: 115px;
  height: 8px;
  background-color: #275271;
}
.no-padding {
  padding: 0px !important;
  margin-top: 7px;
}
.register-bg {
  position: relative;
}
.register-bg::before {
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: fixed;
  opacity: 0.1;
  background-image: url("./../assets/images/register-bg.png");
  background-repeat: repeat;
  background-position: center center;
}
.doctor-header {
  background: #a82824;
  opacity: 0.9;
}
.free-main-header {
  background: #d9e7ee;
  opacity: 0.9;
}
.free-main-header--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 12px;
}
.main-header--wgw {
  width: 125px;
}
.main-header--pto {
  width: 90px;
}
@media only screen and (min-width: 1024px) and (max-width: 2560px) {
  .main-header--wgw {
    width: 240px;
  }
  .main-header--pto {
    width: 200px;
  }
}
.main-header--free {
  width: 280px;
}
.button-container-blue {
  background: #275271;
  opacity: 0.9;
  cursor: pointer;
}
.button-container-red {
  background: #a82824;
  opacity: 0.9;
  position: relative;
  cursor: pointer;
}
.button-container--register {
  font-family: "Fira Sans", sans-serif;
  font-size: 40px;
  line-height: 40px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.doctor-header--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 50px;
  line-height: 50px;
  font-weight: 900;
  width: 50%;
  color: #fff;
  padding-left: 10px;
  padding-top: 20px;
  text-transform: uppercase;
}
.button-container--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.button-container--arrow {
  margin-right: 20px;
}
.free-main-header--margin {
  margin-top: 100px;
}
.button-container--margin {
  margin-bottom: 30px;
}
.button-container--padding {
  padding-top: 50px !important;
  padding-bottom: 50px !important;
}
.button-container--position {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
}
.videoWrapper {
  position: relative;
  width: 95%;
  left: 5%;
  top: 3%;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.button-container--separator {
  position: absolute;
  top: 0;
  width: 115px;
  height: 10px;
  background: #ffffff;
}
.doctors-container--download {
  text-decoration: none;
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #000;
}
.doctors-container--download-text {
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  padding-left: 15px;
}
@media only screen and (max-width: 600px) {
  .button-container--arrow {
    width: 20px;
    margin-right: 5px;
  }
  .button-container--text {
    font-size: 26px;
  }
}
.register-form--noShadow {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Regulations.vue